import { useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../redux/index';
import { useNavigate } from 'react-router-dom';
import PageContext from './PageContext';
import eyeIcon from '../../svgs/eye-details-icon.svg';
import PageTooltip from './PageTooltip'; 
import { TableCell } from '@mui/material';

// pass row object as prop
const CompanyProfileRow = ({ row, count, tableHeader,selectableRows }) =>{
    // get context variables from parent
    const {
        viewModal, 
        setViewModal, 
        viewCompany,  
        setViewCompany, 
    } = useContext(PageContext);
    // redux state for use of persistant state in different route (CompanyDetailsPage)
    const company = useSelector((state) => state.company);
    const companyInfo = useSelector((state) => state.companyInfo);
    const backPath = useSelector((state) => state.backPath); 
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { setCompany, setCompanyInfo, setBackPath } = bindActionCreators(actionCreators, dispatch);

    // event handler for view icon click to show modal that lists sub companies
    const onViewClick = (e) => {
        setViewCompany(viewCompany => viewCompany = row);
        setViewModal(viewModal => viewModal = true);
    }

    const onRowClick = (input) =>{
        //event handler when anywhere in the row is clicked
        if(selectableRows){
            // set back path to let navbar on next page to return to /CompanyProfilePage
            setBackPath('/CompanyProfilePage'); 
            // set company state to bring to new route
            setCompany(input);
            setCompanyInfo(row);
            navigate("/CompanyDetailsPage");
        }
    }

    return(
        <>
            {tableHeader.map(el => {
                // logic to determine how to display each column based on name
                if ( el['columnname'] == 'mastercompanyname'){
                    return(
                        <TableCell onClick={()=>onRowClick(row['mastercompanyname'])} className= {selectableRows ? 'table-cell-clicky' :''}>
                            <div className='table-cell-link-row'>
                                {row[el['columnname']]}
                            </div>
                        </TableCell>
                    );
                }
                else if (el['columnname'] == 'subcompanies'){
                    return (
                        <TableCell onClick={()=>onRowClick(row['mastercompanyname'])} className= {selectableRows ? 'table-cell-clicky' :''}>
                            <PageTooltip title='view'>
                                <img src={eyeIcon} className='data-table-icon-left' onClick={(e)=>{
                                    e.stopPropagation(); // Prevents the TableCell's onClick from firing
                                    onViewClick(e);}}/>
                            </PageTooltip>
                        </TableCell>
                    );
                }
                else if (row[el['columnname']] == null){
                    return(
                        <TableCell onClick={()=>onRowClick(row['mastercompanyname'])} className= {selectableRows ? 'table-cell-clicky' :''}>None</TableCell>
                    );
                }
                else{
                    return(
                        <TableCell onClick={()=>onRowClick(row['mastercompanyname'])} className= {selectableRows ? 'table-cell-clicky' :''}>{row[el['columnname']]}</TableCell>
                    );
                }
            })}
        </>
    );
}

export default CompanyProfileRow;